module.exports = __webpack_public_path__ + "img/sso_icon.4dbe36d4.svg";